// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"d0e3fcec","605":"4ed46555","725":"8b8745e9"}[chunkId] + ".chunk.js";
};